export default __webpack_public_path__ + "static/media/crypto.f133d12e.jpg";